import moment from 'moment-timezone';

export type WingsJournalMonth = {
  code: string;
  month: number; // 1-12
  monthLabel: string;
  email: string;
};

const VAT_SUFFIX = '0884733931';
const TIMEZONE = 'Europe/Brussels';

export const WINGS_JOURNAL_MAILS: WingsJournalMonth[] = [
  {
    code: 'A01',
    month: 1,
    monthLabel: 'januari',
    email: `A01_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A02',
    month: 2,
    monthLabel: 'februari',
    email: `A02_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A03',
    month: 3,
    monthLabel: 'maart',
    email: `A03_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A04',
    month: 4,
    monthLabel: 'april',
    email: `A04_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A05',
    month: 5,
    monthLabel: 'mei',
    email: `A05_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A06',
    month: 6,
    monthLabel: 'juni',
    email: `A06_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A07',
    month: 7,
    monthLabel: 'juli',
    email: `A07_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A08',
    month: 8,
    monthLabel: 'augustus',
    email: `A08_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A09',
    month: 9,
    monthLabel: 'september',
    email: `A09_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A10',
    month: 10,
    monthLabel: 'oktober',
    email: `A10_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A11',
    month: 11,
    monthLabel: 'november',
    email: `A11_${VAT_SUFFIX}@wingscloud.be`,
  },
  {
    code: 'A12',
    month: 12,
    monthLabel: 'december',
    email: `A12_${VAT_SUFFIX}@wingscloud.be`,
  },
];

export const getWingsJournalMailForDate = (
  dateValue?: string | Date | null,
): WingsJournalMonth | null => {
  if (!dateValue) return null;
  const date = moment.tz(dateValue, TIMEZONE);
  if (!date.isValid()) return null;
  const month = date.month() + 1;
  return WINGS_JOURNAL_MAILS.find(entry => entry.month === month) || null;
};

export const wingsJournalComboOptions = () => WINGS_JOURNAL_MAILS.map(entry => ({
  key: entry.email,
  text: `${entry.code} — ${entry.monthLabel}`,
  data: entry,
}));
